import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { SalesChannelSummary } from "@models/sales-channel-summary";
import { DashboardCardComponent } from "@shared/components/cards/dashboard-card/dashboard-card.component";
import {
  PieChartComponent,
  PieChartSegment,
} from "@shared/components/pie-chart/pie-chart.component";
import { SalesChannelPipe } from "@shared/pipes/sales-channel.pipe";
import { SkeletonModule } from "primeng/skeleton";
import { map } from "rxjs";
import { RevenueService } from "@services/revenue.service";

@Component({
  selector: "app-sales-channels-chart-page",
  imports: [
    CommonModule,
    MatIconModule,
    SkeletonModule,
    DashboardCardComponent,
    PieChartComponent,
  ],
  templateUrl: "./sales-channels-chart-page.component.html",
  styleUrl: "./sales-channels-chart-page.component.scss",
})
export class SalesChannelsChartPageComponent {
  private readonly revenueService = inject(RevenueService);
  private readonly salesChannelPipe = new SalesChannelPipe();

  salesChannelSegments$ = this.revenueService
    .getSalesChannelsForOrganizer()
    .pipe(map((items) => this.toChannelSegments(items)));

  private toChannelSegments(items: SalesChannelSummary[]): PieChartSegment[] {
    return items.map((item) => ({
      label: this.salesChannelPipe.transform(item.sales_channel),
      value: item.sales_quantity,
      amount: item.total_amount,
    }));
  }
}
